export default __webpack_public_path__ + "static/skyline2-6a3e8a563dbb3698919a8dba22be576f.png";